import axios from 'axios';
import queryString from 'query-string';

// ----------------------------------------------------------------------

export const httpClient = axios.create({
  withCredentials: false,
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 120 * 1000,
  paramsSerializer: {
    ...axios.defaults.paramsSerializer,
    serialize: params => queryString.stringify(params, { arrayFormat: 'comma' }),
  },
});
